import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';
import {PrimeVm} from 'src/app/view-model/prime/prime.vm';
import {isPlatformBrowser} from '@angular/common';
import {SessionEvent} from '../../event-listeners/session/session.event';

@Component({
  selector: 'app-prime-petal-long',
  templateUrl: './prime-petal-long.component.html',
  styleUrls: ['./prime-petal-long.component.scss'],
})
export class PrimePetalLongComponent implements OnInit {
  @Input() customClasses: string;
  @Input() value;
  @Input() isDetail = true;
  @Input() isCart = false;
  @Input() group = '';
  @Input() isUnique = false;
  @Input() primeOffer = '';
  @Input() priceText = 0;
  @Input() isHalf = false;
  @Input() primeTag = false;

  public petalImage: string;
  public petalStyles: any;
  public ifPrice;
  public primeData;
  isBrowser = true;
  isLogin = false;

  constructor(
    private lsm: LocalStorageManager,
    private vm: PrimeVm,
    private loginEvent: SessionEvent,
    @Inject(PLATFORM_ID) platformId,
  ) {
    this.isBrowser = isPlatformBrowser(platformId) && navigator.userAgent.indexOf('Chrome-Lighthouse') <= -1;
  }

  ngOnInit(): void {
    const algoliaConfig = this.lsm.get('primeConfig')?.[0] ?? {};

    this.vm.getPrimeSubscription().subscribe(res => {
      this.primeData = res;
      this.validateSubscription(res.expirationDate ? res.expirationDate : '');

      this.petalImage = this.primeData.active
        ? algoliaConfig?.feature_prime_sticker?.icon_url_web
        : algoliaConfig?.feature_not_prime_sticker?.icon_url_web;

      this.petalStyles = algoliaConfig;
    });

    this.loginEvent.hasCustomer.subscribe(response => {
      if (!response?.isAnonymous) {
        this.isLogin = !response.isAnonymous;
      }
      if (response.status && this.isBrowser) {
        this.isLogin = !response.isAnonymous;
      }
    });

    this.ifPrice = this.customClasses.includes('--price');
  }

  validateSubscription(expirationDate) {
    if (expirationDate) {
      const today = new Date().getTime();
      this.primeData.active = expirationDate >= today;
    }
  }
}
